'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = createFormatter;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var listStyle = {
  style: 'list-style-type: none; padding: 0; margin: 0 0 0 12px; font-style: normal'
};
var mobxNameStyle = { style: 'color: rgb(232,98,0)' };
var nullStyle = { style: 'color: #777' };

function createFormatter(mobx) {
  var reference = function reference(object, config) {
    if (typeof object === 'undefined') {
      return ['span', nullStyle, 'undefined'];
    } else if (object === 'null') {
      return ['span', nullStyle, 'null'];
    }

    return ['object', { object: object, config: config }];
  };

  var renderIterableHeader = function renderIterableHeader(iterable) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Iterable';
    return ['span', ['span', mobxNameStyle, name], ['span', '[' + iterable.length + ']']];
  };

  var _hasBody = function _hasBody(collection, config) {
    return collection.length > 0 && !(config && config.noPreview);
  };

  var renderIterableBody = function renderIterableBody(collection, mapper) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var children = Object.entries(mobx.toJS(collection)).map(mapper);
    return ['ol', listStyle].concat(_toConsumableArray(children));
  };

  var ObjectFormatter = {
    header: function header(o) {
      if (!mobx.isObservableObject(o)) {
        return null;
      }
      return renderIterableHeader(Object.keys(o), 'Object');
    },

    hasBody: function hasBody(o) {
      return _hasBody(Object.keys(o));
    },
    body: function body(o) {
      return renderIterableBody(o, function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return ['li', {}, reference(key), ': ', reference(value)];
      });
    }
  };

  var ArrayFormatter = {
    header: function header(o) {
      if (!mobx.isObservableArray(o)) {
        return null;
      }
      return renderIterableHeader(o, 'Array');
    },

    hasBody: _hasBody,
    body: function body(o) {
      return renderIterableBody(o, function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            index = _ref4[0],
            value = _ref4[1];

        return ['li', reference(value)];
      });
    }
  };

  return {
    ObjectFormatter: ObjectFormatter,
    ArrayFormatter: ArrayFormatter
  };
}